import { TColumn } from '../../../columns/column.model';

const NOT_IN_LAYOUT = -1;

function findLayoutPosition(column: TColumn, layoutFieldIds: string[]): number {
  const customFieldId = column.customFieldIds?.[0];

  if (!customFieldId) {
    return NOT_IN_LAYOUT;
  }

  return layoutFieldIds.indexOf(customFieldId);
}

function findLastPrecedingIndex(
  columns: TColumn[],
  layoutFieldIds: string[],
  newPosition: number,
): number {
  return columns.reduce((lastIndex, column, index) => {
    const position = findLayoutPosition(column, layoutFieldIds);
    const precedesNewColumn = position !== NOT_IN_LAYOUT && position < newPosition;

    return precedesNewColumn ? index : lastIndex;
  }, NOT_IN_LAYOUT);
}

function findFirstFollowingIndex(
  columns: TColumn[],
  layoutFieldIds: string[],
  newPosition: number,
): number {
  return columns.findIndex((column) => findLayoutPosition(column, layoutFieldIds) > newPosition);
}

export function findLayoutInsertIndex({
  columns,
  newColumn,
  layoutFieldIds,
}: {
  columns: TColumn[];
  newColumn: TColumn;
  layoutFieldIds: string[];
}): number {
  const newPosition = findLayoutPosition(newColumn, layoutFieldIds);

  if (newPosition === NOT_IN_LAYOUT) {
    return columns.length;
  }

  const precedingIndex = findLastPrecedingIndex(columns, layoutFieldIds, newPosition);

  if (precedingIndex !== NOT_IN_LAYOUT) {
    return precedingIndex + 1;
  }

  const followingIndex = findFirstFollowingIndex(columns, layoutFieldIds, newPosition);

  if (followingIndex !== NOT_IN_LAYOUT) {
    return followingIndex;
  }

  return columns.length;
}
